import { types } from 'mobx-state-tree';

const DashBoardStore = types
  .model('dashBoardStore', {
    searchString: '',
    sidebarOpen: false,
  })
  .actions(self => ({
    setSearchString(value) {
      self.searchString = value;
    },
    resetSearchString() {
      self.searchString = '';
    },
    setSidebarOpen(open) {
      self.sidebarOpen = open;
    },
    toggleSidebar() {
      self.sidebarOpen = !self.sidebarOpen;
    },
    resetDashBoardStore() {
      self.searchString = '';
      self.sidebarOpen = false;
    },
  }));

export default DashBoardStore;



// WEBPACK FOOTER //
// ./src/stores/DashBoardStore.js